import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user, checking } = useAuth();

  if (checking) {
    return (
      <div
        data-testid="protected-route-loading"
        className="min-h-screen bg-brand-bg flex items-center justify-center"
      >
        <p className="text-sm text-brand-inkSoft">Loading…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

export default ProtectedRoute;
